import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-top: 22px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
`

const StyledLi = styled.li`
  margin-left: 4px;
  transition: transform 0.1s ease-in-out;

  .my-favorites {
    color: #444;
    font-size: 0.9rem;
    text-decoration: underline;
  }
`

const FavoriteLink = styled.a`
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 20px);
  text-overflow: ellipsis;
  color: #444;
  font-size: 0.9rem;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.colors.green};
  }
`

function MyFavorites({ favorites }) {
  if (!favorites.length) {
    return (
      <StyledUl>
        <StyledLi>Du har ingen valgte favoritter</StyledLi>
      </StyledUl>
    )
  }
  return (
    <StyledUl>
      <StyledLi>
        <Link className="my-favorites" to="/mine-favoritter">
          Se favoritter
        </Link>
      </StyledLi>
      {favorites.map(e => (
        <StyledLi>
          <FavoriteLink href={e.url} target="_blank">
            {e.title}
          </FavoriteLink>
        </StyledLi>
      ))}
    </StyledUl>
  )
}

export default MyFavorites
